import type { AnnotationFrameRecord, FetchedRangesRecord } from '../../../../libraries/storage/types';
import type { AnnotationWritePayload, MetadataPayload } from '../types';
export type FrameAnnotationKey = {
  frameIndex: number;
  annotationId: string;
};
export interface IAnnotationPersistence {
  onWrite(frameIndex: number, annotationId: string, payload: AnnotationWritePayload): void;
  onDelete(frameIndex: number, annotationId: string): void;
  onMetadataWrite(annotationId: string, metadata: MetadataPayload): void;
  onMetadataDelete(annotationId: string): void;
  onFetchedRangesWrite(record: FetchedRangesRecord): void;
  petitionNow(): void;
  getStores(): readonly string[];
  writeToIdb(tx: IDBTransaction, rollbackChannel: (cb: () => void) => void): void;
  /**
   * Returns not-yet-flushed writes and deletes for frames in [start, end]. Lets a chunk
   * load merge in edits made to frames outside the loaded window (e.g. long-range
   * interpolation) before the dirty-set flush reaches IDB — including pending deletes,
   * so a deleted annotation can't be resurrected by a stale IDB/backend read.
   */
  getDirtyRecordsInRange(start: number, end: number): {
    upserts: AnnotationFrameRecord[];
    deletedKeys: FrameAnnotationKey[];
  };
}
export class NoOpPersistence implements IAnnotationPersistence {
  onWrite(_frameIndex: number, _annotationId: string, _payload: AnnotationWritePayload): void {}
  onDelete(_frameIndex: number, _annotationId: string): void {}
  onMetadataWrite(_annotationId: string, _metadata: MetadataPayload): void {}
  onMetadataDelete(_annotationId: string): void {}
  onFetchedRangesWrite(_record: FetchedRangesRecord): void {}
  petitionNow(): void {}
  getStores(): readonly string[] {
    return [];
  }
  writeToIdb(_tx: IDBTransaction, _rollbackChannel: (cb: () => void) => void): void {}
  getDirtyRecordsInRange(_start: number, _end: number): {
    upserts: AnnotationFrameRecord[];
    deletedKeys: FrameAnnotationKey[];
  } {
    return {
      upserts: [],
      deletedKeys: []
    };
  }
}